module.exports = __webpack_public_path__ + "static/img/4.52a87a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/nav-3/4.png
// module id = xUgL
// module chunks = 0